module.exports = __webpack_public_path__ + "img/icon-hot-active.21c8adc.webp";